
  import { Component, Vue } from 'vue-property-decorator';
  import { mapGetters } from 'vuex';

  import Header from '@/components/Core/Header.vue';
  import CookiesControl from '@/components/Core/CookiesControl.vue';
  import Input from '@/components/Core/Input.vue';
  import InputDate from '@/components/Core/InputDate.vue';
  import Checkbox from '@/components/Core/Checkbox.vue';
  import Home from '@/components/Home/Home.vue';
  import OAuth from '@/components/OAuth/OAuth.vue';
  import Login from '@/components/Login/Login.vue';
  import Logout from '@/components/Account/Logout.vue';
  import LoginHome from '@/components/Login/Home.vue';
  import LoginOneStep from '@/components/Login/OneStep.vue';
  import LoginPassword from '@/components/Login/Password.vue';
  import LoginPartner from '@/components/Login/Partner.vue';
  import LoginPartnerCallback from '@/components/Login/PartnerCallback.vue';
  import Register from '@/components/Register/Register.vue';
  import ConfirmRegister from '@/components/Register/ConfirmRegister.vue';
  import RegisterValidate from '@/components/Register/RegisterValidate.vue';
  import PasswordRecovery from '@/components/PasswordRecovery/PasswordRecovery.vue';
  import PasswordRecoverySent from '@/components/PasswordRecovery/PasswordRecoverySent.vue';
  import PasswordRecoveryReset from '@/components/PasswordRecovery/PasswordRecoveryReset.vue';
  import AccountHome from '@/components/Account/Home.vue';
  import Information from '@/components/Account/Information.vue';
  import Newsletter from '@/components/Account/Newsletter.vue';
  import Cookies from '@/components/Account/Cookies.vue';
  import UpdateEmail from '@/components/Account/UpdateEmail.vue';
  import UpdateEmailConfirm from '@/components/Account/UpdateEmailConfirm.vue';
  import UpdateEmailSuccess from '@/components/Account/UpdateEmailSuccess.vue';
  import UpdateUsername from '@/components/Account/UpdateUsername.vue';
  import ResetPassword from '@/components/Account/ResetPassword.vue';
  import ConfirmEmail from '@/components/Register/ConfirmEmail.vue';
  import ConfirmEmailSend from '@/components/Register/ConfirmEmailSend.vue';
  import SteamCallback from '@/components/Steam/Callback.vue';
  import SteamLink from '@/components/Steam/Link.vue';
  import SteamUnlink from '@/components/Steam/Unlink.vue';
  import QualificationSurvey from '@/components/Survey/Qualification.vue';
  import ConfirmQualificationSurvey from '@/components/Survey/Confirm.vue';
  import Error from '@/components/Errors/Error.vue';
  import BadRequest from '@/components/Errors/BadRequest.vue';
  import Internal from '@/components/Errors/Internal.vue';
  import NotFound from '@/components/Errors/NotFound.vue';
  import AgeVerification from '@/components/Login/AgeVerification.vue'
  import AcceptTerms from '@/components/Login/AcceptTerms.vue'
  import AccessRestricted from '@/components/Login/AccessRestricted.vue'

  import tokenService from '@/services/token.service';
  import cookieService from '@/services/cookie.service';
  import { IAgeGateSettingsModel } from './models/login.model';
import accountService from './services/account.service';

  @Component({
    components: {
      Header,
      CookiesControl,
      Input,
      InputDate,
      Checkbox,
      Home,
      OAuth,
      Login,
      Logout,
      LoginHome,
      LoginOneStep,
      LoginPassword,
      LoginPartner,
      LoginPartnerCallback,
      Register,
      ConfirmRegister,
      RegisterValidate,
      PasswordRecovery,
      PasswordRecoverySent,
      PasswordRecoveryReset,
      AccountHome,
      Information,
      Newsletter,
      Cookies,
      UpdateEmail,
      UpdateEmailConfirm,
      UpdateEmailSuccess,
      UpdateUsername,
      ResetPassword,
      ConfirmEmail,
      ConfirmEmailSend,
      SteamCallback,
      SteamLink,
      SteamUnlink,
      QualificationSurvey,
      ConfirmQualificationSurvey,
      Error,
      BadRequest,
      Internal,
      NotFound,
      AgeVerification,
      AcceptTerms,
      AccessRestricted,
    },
    computed: {
      ...mapGetters([
        'user',
        'token',
        'clientId',
        'redirectUrl',
        'cookies'
      ])
    }
  })
  export default class App extends Vue {
    data() {
      return {
        studio: "theme-",
      }
    };

    created() {
      this.LoadCSS("core", true);

      this.$data.studio = "theme-" + this.$data.RCEnvironment.VUE_APP_PARTNER_NAME;

      document.body.classList.add("studio-" + this.$data.RCEnvironment.VUE_APP_PARTNER_NAME);

      cookieService.triggerHistoryEvent(this);

      const url: string = this.$data.RCEnvironment.VUE_APP_ACCOUNT_API_URL + "settings/age-gate"
      accountService.get<IAgeGateSettingsModel>(this, url)
        .then(response => {
          this.$store.dispatch('updateAgeGateSettings', response);
        })

      Vue.nextTick().then(() => {
        const redirect = !this.$router.currentRoute.path.startsWith('/steam') &&
          this.$router.currentRoute.query.link === undefined;
        const checkSteamUrl = !(this.$router.currentRoute.path.startsWith('/steam') && this.$route.query.redirectUrl == null);

        if (this.$router.currentRoute.path.startsWith('/account')) {
          localStorage.setItem("g2g_redirect_url", document.location.origin + this.$router.currentRoute.path);
        }

        tokenService.setToken(this, redirect, checkSteamUrl);
      });
    }

    mounted() {
      this.addRecaptchaScript();

      Vue.nextTick()
        .then(() => {
          this.$store.dispatch("updateRedirectUrl", this.$route.query.redirectUrl);
          this.$store.dispatch("updateClientId", this.$route.query.client_id);
        });
    }

    private addRecaptchaScript(): void {
      if (this.$data.RCEnvironment.VUE_APP_ENABLE_RECAPTCHA == false) {
        return;
      }

      const recaptchaScript = document.createElement("script");
      recaptchaScript.setAttribute("src", "https://www.google.com/recaptcha/api.js?render=" + this.$data.RCEnvironment.VUE_APP_GOOGLE_RECAPTCHA_SITE_KEY);

      document.head.appendChild(recaptchaScript);
    }

    private LoadCSS(feature: string, isFont: boolean = false): void {
      const link: HTMLLinkElement = document.createElement('link');

      link.rel = 'stylesheet';

      if (isFont) {
        link.href = this.$data.RCEnvironment.VUE_APP_MEDIAS_URL.concat(`fonts/${feature}/icon-font-${feature}.css`);
        link.id = `font-icon-${feature}`;
      } else {
        link.href = this.$data.RCEnvironment.VUE_APP_MEDIAS_URL.concat(`styles/${feature}.css`);
      }

      link.crossOrigin = "anonymous";

      const head: HTMLHeadElement = document.getElementsByTagName('head')[0];

      if (head !== null && head !== undefined) {
        document.head.appendChild(link);
      }
    }

  }
